/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { copiriPortalRequest } from '../api/api'; // eslint-disable-next-line
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Table } from 'reactstrap'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader';
import Accordion from './Accordion';
import WalletPassAccordion from './WalletPassAccordion';

const UserMemebrShipCardInformation = ({ data, pageLanguageContent, profileId, showTabData }) => {
	const [cardData, setCardData] = useState([]);
	const [showData, setShowData] = useState(false);
	useEffect(() => {
		if (showTabData && cardData.length <= 0) {
			getCardInformationData(profileId);
		}
		// eslint-disable-next-line
	}, [showTabData]);

	function getCardInformationData(id) {
		setShowData(false);
		setCardData([]);
		copiriPortalRequest('/users/' + id + '/cards', config.app_version, 'get', data)
			.then(response => {
				if (response.data.length > 0) {
					setCardData(response.data);
				}
				setShowData(true);
			})
			.catch(error => {
				setCardData([]);
				setShowData(true);
			});
	}
	return (
		<>
			<fieldset className='border p-2'>
				<legend className='w-auto'>{pageLanguageContent['PRL081'] ? pageLanguageContent['PRL081'] : ''}</legend>
				{showData ? (
					<>
						{cardData && cardData.length > 0 ? (
							<div className='legendAccordian'>
								<Accordion
									cardData={cardData}
									pageLanguageContent={pageLanguageContent}
									showData={showData}
									pageData={data}
									profileId={profileId}
								/>
								<WalletPassAccordion
									cardData={cardData}
									pageLanguageContent={pageLanguageContent}
									profileId={profileId}
								/>
							</div>
						) : (
							<p className='text-center'>{pageLanguageContent['PRL086'] ? pageLanguageContent['PRL086'] : ''}.</p>
						)}
					</>
				) : (
					<CopiriLoader />
				)}
			</fieldset>
		</>
	);
};
export default UserMemebrShipCardInformation;
